import "./../styles.scss";

import { LoadingOutlined } from "@ant-design/icons";
import { Checkbox, notification, Spin } from "antd";
import { Dropdown } from "antd";
import { Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { v4 as uuidv4 } from "uuid";
import * as Yup from "yup";

import AccessControl from "../../../components/common/AccessControl/accessControl";
import DeleteModal from "../../../components/common/Modals/component";
import CloseModal from "../../../components/icons/CloseModal";
import DeleteIcon from "../../../components/icons/DeleteIcon";
import TheeDotsIcon from "../../../components/icons/TheeDotsIcon";
import { encryptString } from "../../../helpers";
const ClientWebHook = (props) => {
  const { getClientSetting, updateClientSetting, id } = props;
  const [initialState] = useState({
    name: "",
    url: "",
    apiHeader: "",
    apiValue: "",
  });

  const [isWebHookModalOpen, setIsWebHookModalOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const [clientSetting, setClientSetting] = useState({});
  const [webhookID, setWebhookID] = useState(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [authorization, setAuthorization] = useState(false);
  const initialValidation = {
    name: Yup.string().required("Required"),
    url: Yup.string().url("Please enter a valid webhook URL").required("Required"),
  };
  const [validationSchema, setValidationSchema] = useState(Yup.object().shape(initialValidation));
  useEffect(() => {
    if (authorization) {
      setValidationSchema(
        Yup.object().shape({
          ...initialValidation,
          apiHeader: Yup.string().required("Required"),
          apiValue: Yup.string().required("Required"),
        }),
      );
    } else {
      setValidationSchema(Yup.object().shape(initialValidation));
    }
  }, [authorization]);

  useEffect(() => {
    fetchClientSetting();
  }, []);

  const fetchClientSetting = async () => {
    const { value } = await getClientSetting({ entityId: id });
    setClientSetting(value?.data || {});
  };

  const handleSubmit = async (data) => {
    setLoader(true);
    const clientWebHookURLs = clientSetting?.webhook?.clientWebHookURLs || [];
    let payload = { ...data, id: uuidv4() };
    if (authorization) {
      payload["apiValue"] = `Encrypted(${encryptString(data.apiValue)})`;
      payload["authorization"] = authorization;
    } else {
      delete payload["apiHeader"];
      delete payload["apiValue"];
    }
    clientWebHookURLs.push(payload);
    updateWebHook(clientWebHookURLs, "add");
  };

  const openModal = () => {
    setIsWebHookModalOpen(true);
  };

  const closeModal = () => {
    setAuthorization(false);
    setIsWebHookModalOpen(false);
  };

  const deleteOpen = () => {
    setDeleteModalOpen(true);
  };

  const updateWebHook = async (clientWebHookURLs, event) => {
    const { value } = await updateClientSetting({ webhook: { clientWebHookURLs }, entityId: id });
    if (value.status) {
      fetchClientSetting();
      if (event === "delete") {
        notification["success"]({ message: "Webhook has been successfully deleted." });
      } else if (event === "add") {
        notification["success"]({ message: "Webhook has been successfully added." });
      }
    } else {
      notification["error"]({ message: value.message });
    }
    setAuthorization(false);
    setDeleteModalOpen(false);
    setLoader(false);
    closeModal();
  };

  const deleteWebhook = async () => {
    setLoader(true);
    let clientWebHookURLs = clientSetting?.webhook?.clientWebHookURLs || [];
    clientWebHookURLs = clientWebHookURLs.filter(({ id }) => id !== webhookID);
    updateWebHook(clientWebHookURLs, "delete");
  };

  const actions = {
    delete: true,
  };

  const handleWebhookTableAction = (profileFeature, menuItems) => {
    for (const key in actions) {
      switch (key) {
        case "delete":
          menuItems.push({
            label: (
              <AccessControl code="delete_client_webhook" page="organization-profile">
                <a rel="noopener noreferrer" onClick={deleteOpen}>
                  <DeleteIcon />
                  <span>Delete</span>
                </a>
              </AccessControl>
            ),
            key: "1",
          });
          break;
      }
    }
  };
  return (
    <>
      <DeleteModal
        setDeleteModalOpen={setDeleteModalOpen}
        modalIsOpen={deleteModalOpen}
        loder={loader}
        deleteComanModel={deleteWebhook}
        header="Delete"
        content="Are you sure you want to delete?"
      />

      <Modal
        isOpen={isWebHookModalOpen}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
        contentLabel="Filter Modal"
        portalClassName="react-modal"
        overlayClassName="modal"
        className="modal-dialog react-modal-dialog-xs modal-dialog-centered filter-modal"
      >
        <div className="modal-content">
          <div className="react-modal-header">
            <h5 className="react-modal-title">Add Webhook</h5>
            <button type="button" onClick={closeModal} className="btn btn__default">
              <CloseModal />
            </button>
          </div>
          <Formik initialValues={initialState} validationSchema={validationSchema} onSubmit={handleSubmit}>
            {({ errors, touched, values, setFieldValue }) => (
              <Form>
                <div className="react-modal-body">
                  <div className="form-container">
                    <div className="field-items mb-4">
                      <label className="form-label">
                        Webhook Name <span className="required">*</span>
                      </label>
                      <Field className="form-control" name="name" type="text" placeholder="Enter Webhook Name" />
                      {touched.name && errors.name && <div className="invalid-feedback">{errors.name}</div>}
                    </div>
                    <div className="field-items mb-4">
                      <label className="form-label">
                        Webhook URL <span className="required">*</span>
                      </label>
                      <Field className="form-control" name="url" type="text" placeholder="Enter Webhook URL" />
                      {touched.url && errors.url && <div className="invalid-feedback">{errors.url}</div>}
                    </div>
                    <div className="field-items mb-4">
                      <Checkbox
                        className="form-label"
                        name="authorization"
                        checked={authorization}
                        onChange={() => {
                          setAuthorization(!authorization);
                        }}
                      >
                        Authorization
                      </Checkbox>
                    </div>
                    {authorization && (
                      <>
                        <div className="field-items mb-4">
                          <label className="form-label">
                            API Header<span className="required">*</span>
                          </label>
                          <Field className="form-control" name="apiHeader" type="text" placeholder="Enter API Header" />
                          {touched.apiHeader && errors.apiHeader && (
                            <div className="invalid-feedback">{errors.apiHeader}</div>
                          )}
                        </div>
                        <div className="field-items mb-4">
                          <label className="form-label">
                            API Key<span className="required">*</span>
                          </label>
                          <Field className="form-control" name="apiValue" type="text" placeholder="Enter API Key" />
                          {touched.apiValue && errors.apiValue && (
                            <div className="invalid-feedback">{errors.apiValue}</div>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </div>
                <div className="react-modal-footer">
                  <div className="react-foo-container">
                    <div className="right-btn-block text-center">
                      <button type="button" className="btn btn-white" onClick={closeModal}>
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-primary">
                        Add
                        {loader && (
                          <Spin
                            size="large"
                            indicator={<LoadingOutlined style={{ fontSize: 50, color: "#000", marginLeft: 50 }} spin />}
                            className="loader__full"
                          ></Spin>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal>

      <div className="col-md-12">
        <div className="border-block groups-block">
          <div className="left-block">
            <h4 className="title-sm-t">Client Webhook</h4>
            <p>Add client webhook for cms publishing.</p>
          </div>
          <div className="right-btn-block">
            <div class="button-container">
              <AccessControl code="add_client_webhook" page="organization-profile">
                <button class="btn btn-primary" onClick={openModal}>
                  Add Webhook
                </button>
              </AccessControl>
            </div>
          </div>
        </div>

        <div className="border-block mt-3">
          <div className="row">
            <div className="col-md-12">
              <div className="table-resposive table-container user-management-table">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Webhook</th>
                      <th style={{ textAlign: "center" }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {clientSetting?.webhook?.clientWebHookURLs?.length > 0 ? (
                      clientSetting?.webhook?.clientWebHookURLs.map((webhook, index) => {
                        return (
                          <>
                            <tr key={index}>
                              <td>
                                {webhook?.name
                                  .split(" ")
                                  .map(
                                    (letter, index) => letter.charAt(0).toUpperCase() + letter.slice(1).toLowerCase(),
                                  )
                                  .join(" ")}
                              </td>
                              <td>{webhook?.url}</td>
                              <td>
                                <div className="table-action-block text-center">
                                  <Dropdown
                                    onClick={() => {
                                      setWebhookID(webhook?.id);
                                    }}
                                    className=""
                                    overlay={
                                      <AccessControl
                                        code="menuItem"
                                        page="organization-profile"
                                        handleTableAction={handleWebhookTableAction}
                                      />
                                    }
                                    trigger={["click"]}
                                    overlayClassName={"tableActionBlock"}
                                    placement={"bottomRight"}
                                  >
                                    <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
                                      <TheeDotsIcon />
                                    </a>
                                  </Dropdown>
                                </div>
                              </td>
                            </tr>
                          </>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="7">
                          <div className="text-center  pt-5 pb-5">
                            <h3>Webhook not found</h3>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                  <tfoot></tfoot>
                </table>
              </div>
            </div>
          </div>
        </div>
        <br />
      </div>
    </>
  );
};
export default ClientWebHook;
